import { Endpoints } from "enums";
import { cometApiRawClient } from "./apiClients";

function downloadBlob(blob: Blob, filename: string): void {
  const url = globalThis.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  globalThis.URL.revokeObjectURL(url);
}

/**
 * Télécharge le fichier d'export des contacts métiers pour la permanence
 * @returns
 */
async function getExportPermanence(fileType: "Csv" | "Xlsx"): Promise<void> {
  const url = `${Endpoints.EXPORT_PERMANENCE}?fileType=${fileType}`;
  const response = await cometApiRawClient.get(url, {
    responseType: "blob",
  });

  const contentDisposition: string = response.headers["content-disposition"];
  const filenameMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);

  const filename =
    filenameMatch?.[1]?.replaceAll(/['"]/g, "").trim() ??
    `Contacts-metiers.${fileType.toLocaleLowerCase()}`;

  const content: Blob = await response.data;

  downloadBlob(content, filename);
}

export const exportService = {
  getExportPermanence,
};
